import { getVuetifyColorForVehicleTypeId } from "@/filters/vehicleTypeColorMap";

export function getColorFromVehicleType(vehicleTypeId?: number | null): string {
  return getVuetifyColorForVehicleTypeId(vehicleTypeId);
}
